import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./Navbar.css";

import Solalogod from '../images/Solalogod.png';

function Navbar({ navbarBackgroundStyle }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll to section if hash exists
  useEffect(() => {
    if (location.hash) {
      const scrollToSection = () => {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          const navbarHeight = document.querySelector(".navbar")?.offsetHeight || 0;
          const elementPosition = element.offsetTop - navbarHeight;
          window.scrollTo({ top: elementPosition, behavior: "smooth" });
        }
      };
      const timeout = setTimeout(scrollToSection, 200); // wait to ensure Home mounts
      return () => clearTimeout(timeout);
    }
  }, [location]);

  // Close mobile menu if open
  const closeMobileMenu = () => {
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector("#navbarNav");
    if (navbarToggler && navbarCollapse.classList.contains("show")) {
      navbarToggler.click();
    }
  };

  // Handle click navigation
  const handleNavLinkClick = (e, path, hash) => {
    e.preventDefault();
    closeMobileMenu();

    if (location.pathname === path && hash) {
      // Scroll immediately if on same page
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        const navbarHeight = document.querySelector(".navbar")?.offsetHeight || 0;
        window.scrollTo({
          top: element.offsetTop - navbarHeight,
          behavior: "smooth",
        });
      }
    } else {
      // Navigate first; scroll handled in useEffect
      navigate(path + hash);
    }
  };

  return (
   <nav
  className="navbar fixed-top navbar-expand-lg navbar-dark"
  style={navbarBackgroundStyle}
>
  <div className="container">
    {/* Logo */}
    <Link className="navbar-brand " to="/" onClick={closeMobileMenu}>
      <img src={Solalogod} alt="Solar Business Logo" />
    </Link>

    {/* Toggler for mobile */}
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* Navbar Links */}
    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul className="navbar-nav">
        <li className="nav-item">
          <Link
            className="nav-link text-white"
            to="/#home"
            onClick={(e) => handleNavLinkClick(e, "/", "#home")}
          >
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link text-white"
            to="/#home-our-services-section"
            onClick={(e) => handleNavLinkClick(e, "/", "#home-our-services-section")}
          >
            Services
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link text-white"
            to="/#home-about-us-section"
            onClick={(e) => handleNavLinkClick(e, "/", "#home-about-us-section")}
          >
            About Us
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link text-white"
            to="/#contact-us-section"
            onClick={(e) => handleNavLinkClick(e, "/", "#contact-us-section")}
          >
            Contact
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link text-white"
            to="/login"
            onClick={closeMobileMenu}
          >
            Login
          </Link>
        </li>
      </ul>
    </div>
  </div>
</nav>

  );
}

export default Navbar;

